import { handleChangeLocaleTime } from '../../../../shared/utils/time';
import Table from '../../../ui/table/Table';

interface IPropsTableUnit {
  data: any;
  page?: number;
  size?: number;
  total?: number;
}

const parseSolution = (solution: string) => {
  switch (solution) {
    case 'machine-manager-solution':
      return '머신 매니저';
    case 'haccp-manager-solution':
      return 'HACCP 매니저';
    case 'machine-gpt':
      return 'Machine GPT';
    case 'relay-point':
      return '릴레이 포인트';
    case 'v-ola':
      return 'V-OLA';
    default:
      return '기타';
  }
};

export default function TableUnit(props: IPropsTableUnit) {
  const { data, page, size } = props;
  return (
    <Table>
      <Table.THead>
        <Table.TRow>
          <Table.TColumn.DefaultColumn size="sm">NO</Table.TColumn.DefaultColumn>
          <Table.TColumn.DefaultColumn size="lg">이름</Table.TColumn.DefaultColumn>
          <Table.TColumn.DefaultColumn size="lg">회사명</Table.TColumn.DefaultColumn>
          <Table.TColumn.DefaultColumn size="lg">이메일</Table.TColumn.DefaultColumn>
          <Table.TColumn.DefaultColumn size="lg">솔루션</Table.TColumn.DefaultColumn>
          <Table.TColumn.DefaultColumn size="md">신청 일자</Table.TColumn.DefaultColumn>
          <Table.TColumn.DefaultColumn size="md">전송 여부</Table.TColumn.DefaultColumn>
        </Table.TRow>
      </Table.THead>
      <Table.TBody>
        {data?.data.result.map((v: any, i: number) => {
          return (
            <Table.TRow key={v.id}>
              <Table.TCell.DefaultCell>{size && page && i + 1 + (page - 1) * size}</Table.TCell.DefaultCell>
              <Table.TCell.DefaultCell>{v.name}</Table.TCell.DefaultCell>
              <Table.TCell.DefaultCell>{v.company}</Table.TCell.DefaultCell>
              <Table.TCell.DefaultCell>{v.email}</Table.TCell.DefaultCell>
              <Table.TCell.DefaultCell>{parseSolution(v.solution)}</Table.TCell.DefaultCell>
              <Table.TCell.DefaultCell>
                {handleChangeLocaleTime(v.createdDt, { includeTime: true })}
                {/* {v.createdat?.substr(0, 10)} */}
              </Table.TCell.DefaultCell>
              <Table.TCell.DefaultCell>{v.success ? '완료' : '미전송'}</Table.TCell.DefaultCell>
            </Table.TRow>
          );
        })}
      </Table.TBody>
    </Table>
  );
}
